/* aurapik infinite scroll — progressive enhancement over Dawn pagination.
   Looks for [data-ap-infinite] (with data-next + data-grid), appends next page's
   grid children as you near the bottom, hides native pagination. Delegated
   wishlist/quick-add listeners keep working on appended cards. */
(function () {
  var sentinel = document.querySelector('[data-ap-infinite]');
  if (!sentinel) return;
  var sel = sentinel.getAttribute('data-grid') || '#product-grid';
  var grid = document.querySelector(sel);
  if (!grid) return;
  var next = sentinel.getAttribute('data-next');

  document.querySelectorAll('.pagination, .pagination-wrapper').forEach(function (p) {
    p.style.display = 'none';
  });
  if (!next) return;

  var loading = false;
  var io = new IntersectionObserver(function (entries) {
    if (entries[0].isIntersecting) load();
  }, { rootMargin: '700px' });
  io.observe(sentinel);

  async function load() {
    if (loading || !next) return;
    loading = true;
    sentinel.classList.add('is-loading');
    try {
      var res = await fetch(next);
      var html = await res.text();
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var newGrid = doc.querySelector(sel);
      if (newGrid) {
        Array.prototype.forEach.call(newGrid.children, function (child) {
          grid.appendChild(child.cloneNode(true));
        });
      }
      var ns = doc.querySelector('[data-ap-infinite]');
      next = ns ? ns.getAttribute('data-next') : '';
      sentinel.setAttribute('data-next', next || '');
      if (window.aurapikWishlist) window.aurapikWishlist.paint();
      if (!next) io.disconnect();
    } catch (e) {
      console.error('aurapik infinite scroll failed', e);
      io.disconnect();
    }
    sentinel.classList.remove('is-loading');
    loading = false;
  }
})();
